/*
 * PasswordSetupPage Messages
 *
 * This contains all the text for the PasswordSetupPage component.
 */
import { defineMessages } from "utils/defineMessages";

export const scope = "app.components.PasswordSetupPage";

export default defineMessages(scope, {
  changePasswordHeader: "Set up log in credentials",
  changePassword: "change password",
  newPasswordLabel: "",
  changeButton: "Change",
  changeUsernameHeader: "Change your username",
  currentUsernameLabel: "Current username",
  changeSuccess: "You have successfully changed your {changedValue}.",
  enterPassword: "Enter password",
  reEnterPassword: "Re-enter Password",
  updatePasswordButton: "Submit",
  errMsgRequiredField: "This field is required!",
  errMsgUnconfirmedPassword: `Passwords do not match`,
  errMsgUnchangedUsername: `Your new username cannot be the same as your old username.`,
  usernameValidationError:
    "Must be 5-100 characters and use supported symbols only",
  duplicateError: "This username is already in use",
  genericValidationError: "Unable to validate username. Please try again.",
  genericErrorHeader: `Error`,
  genericErrorMessage: `Unable to update. Please try again later.`,
  confirmNewPasswordLabel: "",
  userName: "Your username",
  minLength: "At least {length} characters",
  hasLowerCase: "A lowercase letter",
  hasUpperCase: "An uppercase letter",
  hasNumber: "A number",
  hasSymbol: "A symbol",
  noUsername: "Must not contain your username",
  noCommonPassword: "Must not be a commonly used password",
  noFirstName: "Must not contain your first name",
  noLastName: "Must not contain your last name",
});
